var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.isFavorited)?_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.unFavorite(_vm.post)}}},[_vm._v("\n        Article Saved\n    ")]):_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.favorite(_vm.post)}}},[_vm._v("\n        Save Article\n    ")])])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fe029d22","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/Favorite.vue
// module id = 43wb
// module chunks = 0